export enum UserInteractionEventName {
  templateLoadingScreenViewed = "template_loading_screen_viewed",
  templateCardClicked = "template_card_clicked",
  templatesFiltered = "templates_filtered",
}

export const UserInteractionEvent =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";
